import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter-bar segment scheme-medium-dark content" }
const _hoisted_2 = { class: "container-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "segment scheme-light content" }
const _hoisted_5 = { class: "container-content search-results" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-10-10 col-10-lg-2" }
const _hoisted_8 = { class: "facets" }
const _hoisted_9 = { class: "facet-reset" }
const _hoisted_10 = { class: "col-10-10 col-10-lg-8" }
const _hoisted_11 = {
  key: 0,
  class: "search-list inner-row"
}
const _hoisted_12 = { class: "box-grid-vertical" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "card-eyebrow card-category" }
const _hoisted_17 = { class: "card-eyebrow-text" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "card-text row"
}
const _hoisted_20 = { class: "col-12 col-md-6" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "col-12 col-md-6 employees-list-item-links" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-telephone",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_26 = {
  key: 1,
  class: "segment scheme-light content"
}
const _hoisted_27 = {
  key: 2,
  class: "pagination"
}

import { inject, nextTick, ref, Ref, watch } from 'vue';
import FacetsContainer from './components/FacetsContainer.vue';
import PaginationBar from './components/PaginationBar.vue';
import axios, { AxiosResponse } from 'axios';
import {
    getFacetsByFieldName,
    handlePopState,
    handlePushState,
    RequestUrl,
    SolrArguments, SolrDocument,
    SolrResponseData,
    SolrFacet, SolrEmployeeDocument
} from '../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import SearchBar from './components/SearchBar.vue';
import NoResults from './components/NoResults.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchList',
  props: {
    endpoint: {},
    pluginNamespace: {},
    arguments: {},
    allowedFacets: {},
    searchDomain: {}
  },
  setup(__props: any) {

const props = __props;



const i18n = inject('i18n') as { [key: string]: string };
const defaultArguments: SolrArguments = {
    filter: ['type:tx_news_domain_model_news', 'newsIsEvent:true'], // fallback
    page: '1', // required
    perPage: '0', // placeholder, see setPerPage()
    q: '*', // required
    sort: 'relevance desc' // fallback
};

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('tx_solr[q]') !== null) {
    defaultArguments.q = urlParams.get('tx_solr[q]') as string;
}

const allowedFacets = ref([
    props.allowedFacets
]);

const initialArguments: SolrArguments = { ...defaultArguments, ...JSON.parse(props.arguments) as SolrArguments };
const initialUrl = RequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments);

let currentUrl = new RequestUrl(initialUrl);

const listUpdateStatus = ref(false);
const loading = ref(true);

const records: Ref<SolrDocument[]> = ref([]);
const eventList = ref<HTMLElement | null>(null);

const currentPageNumber = ref(parseInt(initialArguments.page));
const totalNumberOfPages = ref(1);
const currentSorting = ref(initialArguments.sort);
const currentSearchTerm = ref(initialArguments.q);

const facets = ref([] as SolrFacet[]);

const spellCheckingSuggestions: Ref<string[]> = ref([]);

watch(records, async () => {
    await nextTick();
    window.initCardWidgets();
});

function loadRecordsAfterPageSelect (page: number): void {
    currentPageNumber.value = page;
    loadRecords();
}

function loadRecordsAfterSearchTermGiven (searchTerm: string): void {
    currentSearchTerm.value = searchTerm;
    // Reset page number
    currentPageNumber.value = 1;
    loadRecords();
}

function loadRecordsAfterFacetChange (name: string, value: string, type: string): void {
    switch (type) {
        case 'add':
            currentUrl.addFilterParameter(`${name}:${value}`);
            break;
        case 'remove':
            currentUrl.removeFilterParameter(`${name}:${value}`);
            break;
        case 'set':
            currentUrl.removeFilter(name);
            currentUrl.addFilterParameter(`${name}:${value}`);
            break;
        default:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            console.trace(`Invalid change type '${type}' (facet change).`);
    }

    loadRecordsAfterPageSelect(1);
}

function loadRecords (): void {
    loading.value = true;
    const url = new RequestUrl(currentUrl);

    if (currentSearchTerm.value.trim() === '') {
        currentSearchTerm.value = '*';
    }

    url.setQuery(currentSearchTerm.value);
    url.setSorting(currentSorting.value);
    url.setPage(currentPageNumber.value);

    axios
        .get(url.toString())
        .then((response: AxiosResponse<SolrResponseData>) => {
            records.value = response.data.documents;
            currentPageNumber.value = response.data.currentPage;
            totalNumberOfPages.value = response.data.lastPage;
            facets.value = getFacetsByFieldName(response.data.facets, allowedFacets.value);
            spellCheckingSuggestions.value = response.data.spellCheckingSuggestions;

            if (history.state.q !== null && typeof history.state.q === 'string' && history.state.q !== currentSearchTerm.value) { // eslint-disable-line @typescript-eslint/no-unsafe-member-access
                handlePushState(currentSearchTerm.value);
            }

            listUpdateStatus.value = true;
            eventList.value?.focus();

            setTimeout(() => {
                listUpdateStatus.value = false;
            }, 2000);

            return undefined;
        })
        .catch((reason: string) =>
            console.trace('Loading of records failed:' + reason)
        )
        .finally(() => {
            loading.value = false;
        });

    currentUrl = url;
}

function resetFilter (): void {
    currentUrl = new RequestUrl(RequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments));
    loadRecordsAfterPageSelect(1);
}

function formattedDate (date: Date): string {
    const lang = document.documentElement.lang;

    return (new Intl.DateTimeFormat(lang === 'de' ? 'de-AT' : 'en-US', {
        timeZone: 'UTC'
    })).format(date);
}

const url = new RequestUrl(currentUrl);
axios.get(url.toString())
    .then((response: AxiosResponse<SolrResponseData>) => {
        records.value = response.data.documents;
        currentPageNumber.value = response.data.currentPage;
        totalNumberOfPages.value = response.data.lastPage;
        facets.value = getFacetsByFieldName(response.data.facets, allowedFacets.value);
        spellCheckingSuggestions.value = response.data.spellCheckingSuggestions;
        handlePushState(currentSearchTerm.value);

        return undefined;
    })
    .catch(() => console.trace('Initial loading of records failed.'))
    .finally(() => {
        loading.value = false;
    });

function employeeEmail (employee: SolrEmployeeDocument): string {
    let email = employee.employeeCollectiveEmail;
    if (employee.employeeEmail) {
        email = employee.employeeEmail;
    }

    if (email && email.length === 4) {
        const [href, token, vector, label] = email;
        // see \Plan2net\FwfSolr\Slots\SearchResultsForEmployees::resultsActionSlot for details how this is constructed
        return '<a '
            + 'href="' + href + '"'
            + ' data-mailto-token="' + token + '" '
            + ' data-mailto-vector="' + vector + '"'
            + '>'
            + '<span>' + label + '</span>'
            + '<i class="icon icon-mail" aria-hidden="true"></i>'
            + '</a>';
    }

    return '';
}

handlePopState(loadRecordsAfterSearchTermGiven);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(SearchBar, {
            key: `search-bar-${currentSearchTerm.value}`,
            "search-term": currentSearchTerm.value,
            onSearch: loadRecordsAfterSearchTermGiven
          }, null, 8 /* PROPS */, ["search-term"]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(FacetsContainer, {
                facets: facets.value,
                onChange: loadRecordsAfterFacetChange
              }, null, 8 /* PROPS */, ["facets"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "button button-reset",
                onClick: resetFilter
              }, _toDisplayString(_unref(i18n).resetFilter), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (records.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (document) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: document.id,
                      class: _normalizeClass(['search-list-item box box-grid box-grid-top-closed', { 'with-link': document.url }])
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass(['card box-grid-horizontal', { 'card-employee': document.type === 'tt_address' }])
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            (document.type === 'tx_fwf_publications_domain_model_publication' && document.url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: document.url,
                                  target: "_blank",
                                  "data-card-link": "href",
                                  rel: "noopener noreferrer"
                                }, _toDisplayString(document.title), 9 /* TEXT, PROPS */, _hoisted_14))
                              : (document.url)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: document.url,
                                    "data-card-link": "href"
                                  }, _toDisplayString(document.title), 9 /* TEXT, PROPS */, _hoisted_15))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(document.title), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              (document.type === 'pages' && document.doktype === 20)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_unref(i18n).program), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (document.type === 'pages' && document.mainCategoryTitle)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(document.mainCategoryTitle), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (document.type === 'pages')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(_unref(i18n).page), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (document.type === 'tx_fwf_publications_domain_model_publication')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode(_toDisplayString(_unref(i18n).publication), 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (document.type === 'tx_fwf_jobs_domain_model_job')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            _createTextVNode(_toDisplayString(_unref(i18n).job), 1 /* TEXT */)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (document.type === 'tt_address' && document.mainDepartmentCategory)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                              _createTextVNode(_toDisplayString(document.mainDepartmentCategory), 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : (document.type === 'tx_fwf_faq_item')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                _createTextVNode(_toDisplayString(_unref(i18n).faq), 1 /* TEXT */)
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : (document.type === 'tx_news_domain_model_news' && props.searchDomain === 'fwf')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                                  _createTextVNode(_toDisplayString(_unref(i18n).news), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : (document.type === 'tx_news_domain_model_news' && props.searchDomain === 'scilog' && document.subCategoryTitle)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                                    _createTextVNode(_toDisplayString(document.subCategoryTitle), 1 /* TEXT */)
                                                  ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", null, [
                              (document.type === 'tx_news_domain_model_news' && document.newsStarttime)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(formattedDate(new Date(document.newsStarttime.toString()))), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (document.type === 'tx_fwf_jobs_domain_model_job' && document.jobClosingDate)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(formattedDate(new Date(document.jobClosingDate.toString()))), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (document.type === 'pages' && document.doktype === 20 && document.programEndtimeStamp)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(formattedDate(new Date(document.programEndtimeStamp as number * 1000))), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (document.type === 'pages' && document.doktype === 20 && document.programStarttimeStamp)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode(_toDisplayString(formattedDate(new Date(document.programStarttimeStamp as number * 1000))), 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "card-eyebrow",
                            innerHTML: document.highlightedContent || document.content
                          }, null, 8 /* PROPS */, _hoisted_18),
                          (document.type === 'tt_address')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((document as SolrEmployeeDocument).employeeFunctionsWithAreas, (functionWithArea, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      _createCommentVNode(" eslint-disable vue/no-v-html "),
                                      _createElementVNode("span", {
                                        class: "employees-list-item-function",
                                        innerHTML: functionWithArea
                                      }, null, 8 /* PROPS */, _hoisted_21)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
                                  _createElementVNode("div", {
                                    innerHTML: employeeEmail(document as SolrEmployeeDocument)
                                  }, null, 8 /* PROPS */, _hoisted_23),
                                  _createElementVNode("a", {
                                    href: 'tel:' + (document.employeeMobile || document.employeePhone)
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(document.employeeMobile || document.employeePhone), 1 /* TEXT */),
                                    _hoisted_25
                                  ], 8 /* PROPS */, _hoisted_24)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */)
                      ])
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (!loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(NoResults, {
                      "spell-checking-suggestions": spellCheckingSuggestions.value,
                      onSearch: loadRecordsAfterSearchTermGiven
                    }, null, 8 /* PROPS */, ["spell-checking-suggestions"])
                  ]))
                : _createCommentVNode("v-if", true),
            (totalNumberOfPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(PaginationBar, {
                    current: currentPageNumber.value,
                    total: totalNumberOfPages.value,
                    onSelect: loadRecordsAfterPageSelect
                  }, null, 8 /* PROPS */, ["current", "total"])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})